import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { DEFAULT_CONTACT } from "@/lib/site-contact";
import { DEFAULT_MARKETING_CONFIG } from "@/lib/site-marketing";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: {
      queryClient,
      seoOverride: null,
      siteImageSlots: null,
      pageContent: {},
      contact: DEFAULT_CONTACT,
      marketing: DEFAULT_MARKETING_CONFIG,
    },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};

// El estado de navegación (history.state) puede transportar datos de precarga
// entre rutas (p. ej. prefill del formulario de facturación). Se declara aquí
// para que navigate({ state: { prefill } }) quede correctamente tipado.
declare module "@tanstack/react-router" {
  interface HistoryState {
    prefill?: Record<string, unknown>;
  }
}
